import { InputProps } from '@lmt/unicorn-shared/app/components/editor/components/blocks/Inputs/types';
import { UIEditorData } from '@lmt/unicorn-shared/app/components/editor/UIEditorTypes';
import { isEmpty } from '@lmt/unicorn-shared/app/components/measurements/copy-datablock-field/common';

type VisibilityContext = {
  values?: UIEditorData;
  sharedValues?: UIEditorData;
  isOnlyView: boolean;
  enabled: boolean;
};

type ContainerPropsLike = {
  isHiddenWhenEmpty?: boolean;
};

function isHiddenEmptyInput(
  props: InputProps,
  ctx: VisibilityContext,
): boolean {
  const value = props.isShared
    ? ctx.sharedValues?.[props.dataKey]
    : ctx.values?.[props.dataKey];

  return !!props.isHiddenWhenEmpty && isEmpty(value) && ctx.isOnlyView;
}

// function for recursive checking emptiness of containers and inputs
function isNodeHideable(
  nodeId: string,
  query: any,
  ctx: VisibilityContext,
): boolean {
  const node = query.node(nodeId).get();
  const name = node.data.name;
  const props = node.data.props;

  if (name === 'Table') {
    return false;
  }

  if (name === 'Input') {
    return isHiddenEmptyInput(props as InputProps, ctx);
  }

  if (name === 'Container') {
    const containerProps = props as ContainerPropsLike;
    if (!containerProps.isHiddenWhenEmpty) {
      return false;
    }

    const childNodeIds: string[] = node.data.nodes ?? [];

    return childNodeIds.every((childNodeId) =>
      isNodeHideable(childNodeId, query, ctx),
    );
  }

  return true;
}

export function shouldHideContainerByChildren(
  childNodeIds: string[],
  query: any,
  ctx: VisibilityContext,
  isContainerHiddenWhenEmpty: boolean,
): boolean {
  if (ctx.enabled || !ctx.isOnlyView) {
    return false;
  }

  if (!isContainerHiddenWhenEmpty) {
    return false;
  }

  return childNodeIds.every((childNodeId) =>
    isNodeHideable(childNodeId, query, ctx),
  );
}
